import { setUser as sentrySetUser } from '@sentry/browser'
import { useAuth } from '@web/src/hooks/use-auth'
import { getAppConfig } from '@web/src/lib/env.dynamic.client'
import { useEffect } from 'react'

/**
 * Syncs the current authenticated user id to Sentry for error reporting context.
 * Does not attach email, name, or other profile fields (PIPEDA safeguards).
 * Renders nothing - this is a side-effect-only component.
 * Place near the root of the app (e.g. in __root.tsx) so it runs for all users.
 */
export function SentryUserSync() {
  const { currentUser } = useAuth()

  useEffect(() => {
    const appConfig = getAppConfig()
    if (!appConfig.SENTRY_DSN_WEB || appConfig.SENTRY_DISABLE) {
      return
    }

    if (currentUser?.profile) {
      sentrySetUser({
        id: currentUser.profile.id,
      })
    } else {
      sentrySetUser(null)
    }
  }, [currentUser?.profile?.id])

  return null
}
